const KEY = 'reseller_portal_referral';

export function saveReferral(resellerTenantId: string): void {
  localStorage.setItem(KEY, resellerTenantId);
}

export function loadReferral(): string | null {
  return localStorage.getItem(KEY);
}

export function clearReferral(): void {
  localStorage.removeItem(KEY);
}
